<template>
    <f7-page>
        <f7-navbar>
            <f7-nav-title/>
        </f7-navbar>

    </f7-page>
</template>

<script>

export default {
    store: ['api', 'user'],
    data () {
        return {

        };
    },

    created: function () {

    },
    mounted: function () { },
    methods: {

    },
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
</style>
